export default "__VITE_ASSET__DdC9JtkS__"